import axios from 'axios';
import withConfig from 'with-config';
import { NewPOI, POI, POIset } from './poi_helpers';

declare global {
    interface Window {
        sso: any;
    }
}

type RequestMethod = "GET"|"POST"|"PUT"|"DELETE"|"PATCH";

interface Request {
    url: string;
    method: RequestMethod;
    headers?: any;
    data?: any;
    params?: any;
    responseType?: any;
}

interface Data { [key: string]: any; }

export function createPOI(new_poi: NewPOI) {
    let url = withConfig.getConfig().api.rt.api_uri + "/pois";
    return apiCall(url, "POST", new_poi);
}

export function fetchPOI(poi_set_id: number) {
    let base_url = withConfig.getConfig().api.rt.api_uri;
    let poi_url = base_url + "/pois";
    let poi_set_url = base_url + "/poi_sets";
    return apiCall(poi_url, "GET").then((pois: POI[]) => {
        return Promise.all([pois, apiCall(poi_set_url, "GET")]);
    }).then((fetched_data) => {
        let pois: POI[] = fetched_data[0];
        let poi_sets: POIset[] = fetched_data[1];
        let poi_set = poi_sets.find(set => set.id === poi_set_id) || { id: 0, poi_ids: [] };
        if (poi_set) {
            return pois.filter(poi => poi_set.poi_ids.includes(poi.id));
        }
        return [];
    });
}


function apiCall(url: string, method: RequestMethod = "GET", data: Data|null = null, params = null, response_type = null) {
    let stack = new Error().stack;

    let req: Request = {
        url: url,
        method: method
    };
    if (window.hasOwnProperty("sso") && window.sso !== undefined && window.sso.hasOwnProperty("getJWT")) {
        const jwt_token = window.sso.getJWT().getRaw();
        req.headers = { 'Authorization': `Bearer ${ jwt_token }` };
    }
    if (data) {
        req.data = data;
    }
    if (params) {
        req.params = params;
    }
    if (response_type) {
        req.responseType = response_type;
    }
    return axios(req).then((res) => {
        return res.data;
    }).catch((err) => {
        err.stack = stack;
        err.network_error = true;
        throw err;
    });
}


// WEBPACK FOOTER //
// ./src/helpers/api_helpers.ts